import { useEffect, useState } from "react"

import { useAdminState, useAdminDispatch, ActionCreators } from "../Context"
import { CompaniesApi } from "../api"
import { toTableData } from "common/helpers/admin-page-func.helper"
import { Form } from "components/pages/catalogs/admin/FormDialog"
import { AdminFormDialog } from "components/partials"
import { CatalogsApi } from "common/api"
import { AdminDeleteDialog } from "components/partials"

const CatalogFormDialog = props => {
    const { catalog, DialogProps } = props
    const { params } = useAdminState()
    const { filter, pagination } = params
    const dispatch = useAdminDispatch()

    const [confirmDelete, setConfirmDelete] = useState(false)
    const [catalogData, setCatalogData] = useState(null)

    useEffect(() => {
        if (typeof catalog.id !== "string") return
        CatalogsApi.getOne(catalog.id).then(response => {
            setCatalogData(response.data)
        })
    }, [catalog.id])

    async function submitCallback(formData) {
        await CatalogsApi.update(formData)
        updateTable()
    }

    async function updateTable() {
        if (!filter || !pagination) return

        const getResponse = await CompaniesApi.get({
            filter,
            pagination,
            refetch: true
        })
        dispatch(ActionCreators.loaded(toTableData(getResponse)))
    }

    function onClickDelete() {
        setConfirmDelete(true)
    }

    async function onConfirmDelete() {
        if (typeof catalog.id !== "string") return

        await CatalogsApi.remove(catalog.id)
        setConfirmDelete(false)
        updateTable()
    }

    function onExited(node) {
        setConfirmDelete(false)

        if (DialogProps.TransitionProps?.onExited) {
            DialogProps.TransitionProps.onExited(node)
        }
    }

    if (!catalogData) {
        return null
    }

    return (
        <>
            <AdminFormDialog
                formData={catalogData}
                submitCallback={submitCallback}
                onClickDelete={onClickDelete}
                FormComponent={Form}
                DialogProps={{
                    ...DialogProps,
                    TransitionProps: {
                        onExited
                    },
                    PaperProps: {
                        style: {
                            maxWidth: "min-content"
                        }
                    }
                }}
                DialogTitleProps={{
                    children: "Edit Catalog"
                }}
            />

            <AdminDeleteDialog
                selected={confirmDelete ? 1 : 0}
                deleteCallback={onConfirmDelete}
                DialogProps={{
                    TransitionProps: {
                        onExited
                    }
                }}
            />
        </>
    )
}

export default CatalogFormDialog
